import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import { ReportSatViewResponse, ReportSatViewPayload } from './report-sat-v2.type';

export async function reportSatViewService({ query: rawQuery }: ReportSatViewPayload) {
  const query = transformIntoQueryParamString(rawQuery);
  const { response, data } = await BACKEND.post<ReportSatViewResponse>(ENDPOINT.REPORT_SAT_V2, { query });
  return {
    response,
    summary: data,
  };
}
